import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BreadCrumbModel } from './breadcrumb.model';
import { BreadCrumbPropertyModel } from './breadCrumb-property.model';
import { Router } from '@angular/router';
import { BREADCRUMBS } from '../../../../../config/breadcrumb.config';

@Injectable()
export class BreadCrumbService {
  private sessionBreadCrumbs: BreadCrumbModel[];
  private sessionSource: string;
  private staticBreadCrumbs: BreadCrumbModel[];

  private breadCrumbProperty: BreadCrumbPropertyModel;
  private breadCrumbs: Subject<BreadCrumbModel> = new Subject<BreadCrumbModel>();
  public obvBreadCrumb: Observable<BreadCrumbModel> = this.breadCrumbs.asObservable(); // convert to Observable for subscribing

  constructor(private router: Router, ) {
  }

  setCurrentBreadCrumb(path: BreadCrumbModel) {
    this.breadCrumbs.next(path);
  }

  getCurrentBreadCrumb(): Observable<BreadCrumbModel> {
    return this.obvBreadCrumb;
  }

  /**
   * Storing Breadcrumb in session
   * @param breadCrumb 
   */
  setBreadCrumbs(breadCrumb: BreadCrumbModel) {
    let breadCrumbModel: BreadCrumbModel;
    const breadCrumbsMapObject: Map<string, string> = new Map<string, string>();
    this.sessionBreadCrumbs = this.getBreadCrumbs();
    if (this.staticBreadCrumbs && this.staticBreadCrumbs.length > 0) {
      // Creating static breadcrumbs
      this.sessionBreadCrumbs = [];
      this.setStaticBreadCrumbValues(breadCrumb);
    } else if (this.sessionBreadCrumbs) {
      this.checkBreadCrumbDataAlreadyExist(breadCrumb);
      // Iterate the exist breadcrumb from session part and
      // adding in map with key as label and value as routerlink
      this.sessionBreadCrumbs.forEach((value) => {
        // breadCrumbsMapObject.set(value.label, value.routerLink);
        breadCrumbsMapObject.set(value.routerLink, value.label);
      });
      // Adding the latest breadCrumb property in Map object 
      // breadCrumbsMapObject.set(breadCrumb.label, breadCrumb.routerLink);
      breadCrumbsMapObject.set(breadCrumb.routerLink, breadCrumb.label);

      this.sessionBreadCrumbs = [];
      breadCrumbsMapObject.forEach((value, key) => {
        breadCrumbModel = new BreadCrumbModel();
        /*breadCrumbModel.label = key;
        breadCrumbModel.routerLink = value;*/
        breadCrumbModel.label = value;
        breadCrumbModel.routerLink = key;
        this.sessionBreadCrumbs.push(breadCrumbModel);
      });
    } else {
      this.sessionBreadCrumbs = [];
      this.sessionBreadCrumbs.push(breadCrumb);
    }
    this.createSessionBreadCrumbs(this.sessionSource === undefined ? this.getSource() : this.sessionSource, this.sessionBreadCrumbs);
  }

  /**
     * Storing Static Breadcrumb in session
     * @param breadCrumb
     */
  setStaticBreadCrumbs(url: string) {
    const currentUrl = this.filterCurrentUrl(url);
    const isStaticBreadCrumb = BREADCRUMBS.staticBreadCrumbAvailable.find((data) => (data === currentUrl));
    if (isStaticBreadCrumb) {
      this.createStaticBreadCrumbs(currentUrl);
    }
  }

  /**
   * Get the breadcrumb data from session
   */
  getBreadCrumbs(): BreadCrumbModel[] {
    let breadCrumbProperty = new BreadCrumbPropertyModel();
    breadCrumbProperty = this.getBreadCrumbProperty();
    if (breadCrumbProperty) {
      return breadCrumbProperty.breadCrumbs;
    } else {
      return undefined;
    }
  }

  getSource(): string {
    let breadCrumbProperty = new BreadCrumbPropertyModel();
    breadCrumbProperty = this.getBreadCrumbProperty();
    if (breadCrumbProperty) {
      return breadCrumbProperty.source;
    } else {
      return undefined;
    }
  }

  setSource(url) {
    this.sessionSource = this.filterCurrentUrl(url);
  }

  /**
   * Get breadcrumb property
   */
  getBreadCrumbProperty(): BreadCrumbPropertyModel {
    return JSON.parse(sessionStorage.getItem('breadCrumb'));
  }

  /**
   * Remove breadCrumb session
   */
  removeBreadCrumbs() {
    sessionStorage.removeItem('breadCrumb');
  }

  /***
   * Remove breadCrumb property from breadcrumb session
   * @param breadCrumbModel
   */
  removeSessionBreadCrumbProperty(rowIndex) {
    let breadCrumbModelArray: BreadCrumbModel[] = [];
    this.sessionBreadCrumbs = this.getBreadCrumbs();
    if (this.sessionBreadCrumbs) {
      breadCrumbModelArray = this.sessionBreadCrumbs.filter((data, index) => (index < rowIndex));
      this.createSessionBreadCrumbs(this.getSource(), breadCrumbModelArray);
    }
  }

  /***
   * Removing last breadcrumb property from breadcrumb session
   */
  removeLastBreadCrumb() {
    this.sessionBreadCrumbs = this.getBreadCrumbs();
    this.sessionBreadCrumbs.pop();
    this.createSessionBreadCrumbs(this.getSource(), this.sessionBreadCrumbs);
  }

  /**
   * Change Source in session breadCrumb property
   */

  changeSessionSource(source: string) {
    this.sessionBreadCrumbs = this.getBreadCrumbs();
    this.createSessionBreadCrumbs(source, this.sessionBreadCrumbs);
  }

  /**
   *  Find index if exist in the session
   */
  checkBreadCrumbDataAlreadyExist(breadCrumbModel: BreadCrumbModel) {
    let index;
    let breadCrumbModelArray: BreadCrumbModel[] = [];
    const findBreadCrumbObject = this.sessionBreadCrumbs.find((value) => (value.label === breadCrumbModel.label));
    if (findBreadCrumbObject) {
      index = this.sessionBreadCrumbs.findIndex((data) => (data === findBreadCrumbObject));
      if (index !== undefined) {
        breadCrumbModelArray = this.sessionBreadCrumbs.filter((data, rowIndex) => (rowIndex < index));
        this.sessionBreadCrumbs = breadCrumbModelArray;
      }
    }
  }

  getLastUrlFromBreadCrumb(): BreadCrumbModel {
    let breadCrumbModel: BreadCrumbModel;
    this.sessionBreadCrumbs = this.getBreadCrumbs();
    if(this.sessionBreadCrumbs){
      breadCrumbModel = this.sessionBreadCrumbs[this.sessionBreadCrumbs.length - 1];
    }
    return breadCrumbModel;
  }

  createStaticBreadCrumbs(currentUrl: string) {
    let breadCrumbModel: BreadCrumbModel;
    this.staticBreadCrumbs = [];
    this.sessionSource = currentUrl;
    const result = BREADCRUMBS['static' + currentUrl];
    result.forEach((value) => {
      breadCrumbModel = new BreadCrumbModel();
      breadCrumbModel.label = value.label;
      breadCrumbModel.routerLink = value.routerLink;
      this.staticBreadCrumbs.push(breadCrumbModel);
    });
  }

  setStaticBreadCrumbsFromSession() {
    this.staticBreadCrumbs = this.getBreadCrumbs();
  }

  setStaticBreadCrumbValues(breadcrumb) {
    const breadCrumbsMapObject: Map<string, string> = new Map<string, string>();
    this.staticBreadCrumbs.forEach((value) => {
      // breadCrumbsMapObject.set(value.label, value.routerLink);
      breadCrumbsMapObject.set(value.routerLink, value.label);
    });
    // breadCrumbsMapObject.set(breadcrumb.label, breadcrumb.routerLink);
    breadCrumbsMapObject.set(breadcrumb.routerLink, breadcrumb.label);
    let breadCrumbModel: BreadCrumbModel;
    breadCrumbsMapObject.forEach((value, key) => {
      breadCrumbModel = new BreadCrumbModel();
      /*breadCrumbModel.label = key;
      breadCrumbModel.routerLink = value;*/
      breadCrumbModel.label = value;
      breadCrumbModel.routerLink = key;
      this.sessionBreadCrumbs.push(breadCrumbModel);
    });
  }

  filterCurrentUrl(url: string): string {
    let filteredUrl;
    let slashAvailable = 0, secondSlashIndex = 0;
    for (let i = 0; i < url.length; i++) {
      const char = url.charAt(i);
      if (char === '/') {
        if (slashAvailable === 1) {
          secondSlashIndex = i;
        }
        slashAvailable++;
      }
    }
    if (slashAvailable > 1) {
      filteredUrl = url.substring(1, secondSlashIndex);
    } else {
      filteredUrl = url.substring(1, url.length);
    }
    return filteredUrl;
  }

  createSessionBreadCrumbs(source: string, breadCrumbs: BreadCrumbModel[]) {
    this.breadCrumbProperty = new BreadCrumbPropertyModel();
    this.breadCrumbProperty.source = source;
    this.breadCrumbProperty.breadCrumbs = breadCrumbs;
    sessionStorage.setItem('breadCrumb', JSON.stringify(this.breadCrumbProperty));
    this.staticBreadCrumbs = [];
    this.sessionSource = undefined;
  }
}
